import ReportsPage from "@/pages/reports";
import PrivateLayout from "@/components/layouts/private-layout";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/reports/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateLayout>
      <ReportsPage />
    </PrivateLayout>
  );
}
